module.exports = __webpack_public_path__ + "img/tex_dt03.e40eb98e.svg";